export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 128

export const passwordValidationRules = {
  required: 'Password is required',
  minLength: {
    value: PASSWORD_MIN_LENGTH,
    message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
  },
  maxLength: {
    value: PASSWORD_MAX_LENGTH,
    message: `Password cannot exceed ${PASSWORD_MAX_LENGTH} characters`,
  },
}

export const optionalPasswordValidationRules = {
  validate: (value) => {
    if (!value || value.trim() === '') return true
    if (value.length < PASSWORD_MIN_LENGTH) {
      return `Password must be at least ${PASSWORD_MIN_LENGTH} characters`
    }
    if (value.length > PASSWORD_MAX_LENGTH) {
      return `Password cannot exceed ${PASSWORD_MAX_LENGTH} characters`
    }
    return true
  },
}
